module.exports = {
  /* 01.General */
  "chat.end":"เริ่มการสนทนาของคุณใหม่",
  "chat.endall":"สิ้นสุดการแชท",
  "chat.cancel":"ยกเลิก",
  "chat.cookie":"ผู้ช่วยดิจิทัลนี้ใช้คุกกี้เพื่อให้แน่ใจว่าคุณได้รับประสบการณ์ที่ดีที่สุด",
  "chat.learn":"เรียนรู้เพิ่มเติม",
  "chat.minimize":"ย่อเล็กสุด",
  "chat.hide":"ปิด I",
  "chat.hidebot.text":"ปิดจะทำให้อวาตาร์หายไปเป็นเวลา 15 นาที",
  "chat.hidebot":"ปิดบอท",
  "chat.restart":"เริ่มต้นใหม่",
  "switch.language":"เปลี่ยนภาษา",
  "switch.property":"เปลี่ยนคุณสมบัติ",
  "restart.converstation":"เริ่มการสนทนาใหม่",
  "chat.endtext":"คุณแน่ใจหรือไม่ว่าต้องการสิ้นสุดการแชทปัจจุบัน",
  "check.availabity":"ตรวจสอบห้องว่าง",
  "check.availabity.submit":"ส่ง",
  "check.availabity.cancel":"ยกเลิก",
  "check.availabity.adults":"ผู้ใหญ่ ",
  "check.availabity.children":"เด็ก",
  "check.availabity.child.age":"อายุ - เด็ก",
  "feedback.leave":"แสดงความคิดเห็น",
  "feedback.leave.message":"ทิ้งข้อความไว้",
};
